import { Link } from "react-router-dom";
import { comics } from "@/mocks/comics";

export default function FeaturedComics() {
  const featured = comics.slice(0, 3);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            编辑团队精心挑选的高品质韩漫，口碑爆棚，不容错过
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {featured.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className={`group block rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer ${
                index === 0 ? "bg-foreground-950 text-background-50" : "bg-background-100"
              }`}
              data-product-shop=""
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                    {comic.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className={`font-heading text-lg font-bold mb-2 ${index === 0 ? "text-background-50" : "text-foreground-950"}`}>
                  {comic.title}
                </h3>
                <p className={`text-xs mb-3 line-clamp-2 ${index === 0 ? "text-background-200" : "text-foreground-500"}`}>
                  {comic.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className={`text-sm font-medium ${index === 0 ? "text-primary-400" : "text-primary-500"}`}>
                    更新至第{comic.latestChapter}话
                  </span>
                  <span className={`text-xs ${index === 0 ? "text-background-300" : "text-foreground-400"}`}>
                    {comic.views}阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}